import React, { useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import UploadButton from '../../components/UploadButton';
import { FaUpload } from 'react-icons/fa';
import ReactSelect from '../../components/ReactSelect';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function EventoImportarEventos() {
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const token = localStorage.getItem('token');
    const [clienteSelecionado, setClienteSelecionado] = useState(null);
    const history = useHistory();

    const [dados, setDados] = useState({
        empresa: empresa,
        nomeEmpresa: nomeEmpresa
    });

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Importar Eventos do Excel</h1></div>
                    <div className="fin-pp__actions"></div>
                </div>

                <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                    <div className="fin-pp__filters">
                        <div className="fin-pp__field" style={{ flex: '0 0 50%' }}>
                            <label className="fin-pp__label">Cliente</label>
                            <ReactSelect
                                id="cliente"
                                value={clienteSelecionado}
                                onChange={e => setClienteSelecionado(e)}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/participante',
                                        token: token,
                                        params: {
                                            nome: input,
                                            tipoCadastro: "cliente",
                                            situacaoRegistro: "ativo",
                                        }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                var label = registro.codigo +
                                                    ' - ' + registro.nome +
                                                    (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                    (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                    (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                    (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                return {
                                                    value: registro.id,
                                                    label: label,
                                                    modelo: registro.modelo
                                                };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            console.log(error);
                                            return [];
                                        });
                                }}
                                placeholder="Selecione o cliente..."
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: 16 }}>
                        <UploadButton
                            icon={<FaUpload size={20} />}
                            color="primary"
                            acaoApi={"eventoImportarEventos"}
                            title="Selecionar Arquivo Excel"
                            disabled={!clienteSelecionado}
                            beforeSend={() => {
                                if (!clienteSelecionado) {
                                    toast.error('Selecione um cliente primeiro');
                                    return false;
                                }
                                toast.info('Aguarde, isso pode levar alguns minutos');
                            }}
                            callBack={(data) => {
                                if (data.result === "sucesso") {
                                    toast.success('Importação finalizada com sucesso!');
                                    history.push("/evento");
                                } else {
                                    toast.error(data.message || data.error || "Erro desconhecido");
                                }
                            }}
                            dados={{
                                empresa: empresa,
                                operador: localStorage.getItem("idUsuario"),
                                cliente: clienteSelecionado?.value
                            }}
                        >Selecionar Arquivo Excel</UploadButton>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
